'use strict';

import VZSpinner from 'Components/VZSpinner';
import { showErrorModal } from 'Root/modal';

export default class VZAddBase extends HTMLElement {
    constructor() {
        super();
        this.form = document.querySelector('#product-form');
        this.editMode = document.querySelector('.js-edit-mode');
        this.spinner = document.querySelector('vz-spinner') || new VZSpinner();
    }

    /**
     * @function getAddons
     * @return {string} - Selected addons stringified
     * @description Returns the selected addons
     */
    static getAddons() {
        return document.getElementById('addons')?.value || '[]';
    }

    /**
     * @function getAllProducts
     * @return {Array} - An array of linked products or an empty Array.
     * @description Looks for all one net products: additional, required, optional.
     */
    static getAllProducts() {
        const additionalProducts = JSON.parse(document.getElementById('additionalProducts')?.value || '[]');
        const requiredBusinessRulesProducts = JSON.parse(document.getElementById('requiredBusinessRulesProducts')?.value || '[]');
        const optionalBusinessRulesAddons = JSON.parse(document.getElementById('optionalBusinessRulesAddons')?.value || '[]');
        const allProducts = [...additionalProducts, ...requiredBusinessRulesProducts, ...optionalBusinessRulesAddons]
            .filter((item) => item)
            .filter((product) => product.pid && product.quantity);

        return allProducts || [];
    }

    /**
     * @function getPAID
     * @return {HTMLInputElement} hidden input containing the PAID
     * @description Gets the PAID input field
     */
    static getPAID() {
        return document.getElementById('paid');
    }

    /**
     * @function handleNetworkError
     * @description This function is called when adding to the basket for business internet products returns a 500.
     */
    static handleNetworkError() {
        const { title, body, cta } = JSON.parse(document.querySelector('vz-product-card').dataset.generalError);
        showErrorModal(title, body, cta);
    }
}
